export enum MitigationPlanTaskSource {
  Recommendation = 1,
  AdHoc = 2
}
